import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	RequestOtpEmail,
	type RequestOtpEmailMutation,
	type RequestOtpEmailMutationVariables,
} from './requestOtpEmail.graphql';

export type RequestOtpEmailResponse = RequestOtpEmailMutation['requestOtpEmail'];

export async function requestOtpEmail(
	input: RequestOtpEmailMutationVariables['input'],
	{ gql: { fetch } }: UtilityContext,
): Promise<RequestOtpEmailResponse> {
	const { data } = await fetch<RequestOtpEmailMutation, RequestOtpEmailMutationVariables>({
		path: '/login',
		query: RequestOtpEmail,
		variables: { input },
		rejectOnError: true,
		batched: false, // to ensure this rate limited mutation is not batched
	});
	return data.requestOtpEmail;
}
